export default __webpack_public_path__ + "15a48c0db11f2a6167f6974b04a78b77.png";